import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=174f8067&scoped=true"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
import style0 from "./Part.vue?vue&type=style&index=0&id=174f8067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f8067",
  null
  
)

export default component.exports